export const ASYMPTOMATIC_US_STATES = [
  { code: "AL", label: "Alabama" },
  { code: "AK", label: "Alaska" },
  { code: "AZ", label: "Arizona" },
  { code: "AR", label: "Arkansas" },
  { code: "CA", label: "California" },
  { code: "CO", label: "Colorado" },
  { code: "CT", label: "Connecticut" },
  { code: "DE", label: "Delaware" },
  { code: "FL", label: "Florida" },
  { code: "GA", label: "Georgia" },
  { code: "HI", label: "Hawaii" },
  { code: "ID", label: "Idaho" },
  { code: "IL", label: "Illinois" },
  { code: "IN", label: "Indiana" },
  { code: "IA", label: "Iowa" },
  { code: "KS", label: "Kansas" },
  { code: "KY", label: "Kentucky" },
  { code: "LA", label: "Louisiana" },
  { code: "ME", label: "Maine" },
  { code: "MD", label: "Maryland" },
  { code: "MA", label: "Massachusetts" },
  { code: "MI", label: "Michigan" },
  { code: "MN", label: "Minnesota" },
  { code: "MS", label: "Mississippi" },
  { code: "MO", label: "Missouri" },
  { code: "MT", label: "Montana" },
  { code: "NE", label: "Nebraska" },
  { code: "NV", label: "Nevada" },
  { code: "NH", label: "New Hampshire" },
  { code: "NJ", label: "New Jersey" },
  { code: "NM", label: "New Mexico" },
  { code: "NY", label: "New York" },
  { code: "NC", label: "North Carolina" },
  { code: "ND", label: "North Dakota" },
  { code: "OH", label: "Ohio" },
  { code: "OK", label: "Oklahoma" },
  { code: "OR", label: "Oregon" },
  { code: "PA", label: "Pennsylvania" },
  { code: "RI", label: "Rhode Island" },
  { code: "SC", label: "South Carolina" },
  { code: "SD", label: "South Dakota" },
  { code: "TN", label: "Tennessee" },
  { code: "TX", label: "Texas" },
  { code: "UT", label: "Utah" },
  { code: "VT", label: "Vermont" },
  { code: "VA", label: "Virginia" },
  { code: "WA", label: "Washington" },
  { code: "WV", label: "West Virginia" },
  { code: "WI", label: "Wisconsin" },
  { code: "WY", label: "Wyoming" },
  { code: "DC", label: "District of Columbia" },
  { code: "AS", label: "American Samoa" },
  { code: "GU", label: "Guam" },
  { code: "MP", label: "Northern Mariana Islands" },
  { code: "PR", label: "Puerto Rico" },
  { code: "UM", label: "United States Minor Outlying Islands" },
  { code: "VI", label: "Virgin Islands, U.S. (VI)" },
];

export const RACE_OPTIONS = [
  {
    label: "White",
    value: "White",
  },
  {
    label: "Black or African American",
    value: "Black or African American",
  },
  {
    label: "American Indian or Alaska Native",
    value: "American Indian or Alaska Native",
  },
  {
    label: "Asian Indian",
    value: "Asian Indian",
  },
  {
    label: "Chinese",
    value: "Chinese",
  },
  {
    label: "Filipino",
    value: "Filipino",
  },
  {
    label: "Japanese",
    value: "Japanese",
  },
  {
    label: "Korean",
    value: "Korean",
  },
  {
    label: "Vietnamese",
    value: "Vietnamese",
  },
  {
    label: "Other Asian",
    value: "Other Asian",
  },
  {
    label: "Native Hawaiian",
    value: "Native Hawaiian",
  },
  {
    label: "Other",
    value: "Other",
  },
];

export const ETHNICITY_OPTIONS = [
  {
    label: "Not of Hispanic, Latino/a or Spanish origin",
    value: "Not of Hispanic, Latino/a or Spanish origin",
  },
  {
    label: "Mexican, Mexican American, Chicano/a",
    value: "Mexican, Mexican American, Chicano/a",
  },
  {
    label: "Puerto Rican",
    value: "Puerto Rican",
  },
  {
    label: "Cuban",
    value: "Cuban",
  },
  {
    label: "Another Hispanic, Latino/a or Spanish origin",
    value: "Another Hispanic, Latino/a or Spanish origin",
  },
  {
    label: "Other",
    value: "Other",
  },
];

export const ALSFRS_FIELDS = [
  {
    id: 1,
    title: "Speech",
    text: "speech",
    content: [
      {
        subId: 1,
        subtitle: "Normal speech process",
        points: 4,
      },
      {
        subId: 102,
        subtitle: "Detectable speech disturbance",
        points: 3,
      },
      {
        subId: 103,
        subtitle: "Intelligible with repeating",
        points: 2,
      },
      {
        subId: 104,
        subtitle: "Speech combined with \n non-vocal communication",
        points: 1,
      },
      {
        subId: 105,
        subtitle: "Loss of useful speech",
        points: 0,
      },
    ],
  },
  {
    id: 2,
    title: "Salivation",
    text: "salvation",
    content: [
      {
        subId: 106,
        subtitle: "Normal",
        points: 4,
      },
      {
        subId: 107,
        subtitle:
          "Slight but definite excess of saliva in mouth, may have nighttime drooling",
        points: 3,
      },
      {
        subId: 108,
        subtitle:
          "Moderately excessive saliva, may have minimal drooling (during the day)",
        points: 2,
      },
      {
        subId: 109,
        subtitle: "Marked excess of saliva with some drooling",
        points: 1,
      },
      {
        subId: 110,
        subtitle: "Marked drooling, requires constant tissue or handkerchief",
        points: 0,
      },
    ],
  },
  {
    id: 3,
    title: "Swallowing",
    text: "swallowing",
    content: [
      {
        subId: 111,
        subtitle: "Normal eating habits",
        points: 4,
      },
      {
        subId: 112,
        subtitle: "Early eating problems – occasional choking",
        points: 3,
      },
      {
        subId: 113,
        subtitle: "Dietary consistency changes",
        points: 2,
      },
      {
        subId: 114,
        subtitle: "Needs supplement tube feeding",
        points: 1,
      },
      {
        subId: 115,
        subtitle: "NPO (exclusively parenteral or enteral feeding)",
        points: 0,
      },
    ],
  },
  {
    id: 4,
    title: "Handwriting",
    text: "handwriting",
    content: [
      {
        subId: 116,
        subtitle: "Normal",
        points: 4,
      },
      {
        subId: 117,
        subtitle: "Slow or sloppy: all words are legible",
        points: 3,
      },
      {
        subId: 118,
        subtitle: "Not all words are legible",
        points: 2,
      },
      {
        subId: 119,
        subtitle: "Able to grip pen, but unable to write",
        points: 1,
      },
      {
        subId: 120,
        subtitle: "Unable to grip pen",
        points: 0,
      },
    ],
  },
  {
    id: 5,
    title: "Cutting food and handling utensils (Patients without gastrostomy)",
    text: "cutting_food_a",
    content: [
      {
        subId: 121,
        subtitle: "Normal",
        points: 4,
      },
      {
        subId: 122,
        subtitle: "Somewhat slow and clumsy, but no help needed ",
        points: 3,
      },
      {
        subId: 123,
        subtitle:
          "Can cut most foods (>50%), although slow and clumsy, some help needed",
        points: 2,
      },
      {
        subId: 124,
        subtitle: "Food must be cut by someone, but can still feed slowly",
        points: 1,
      },
      {
        subId: 125,
        subtitle: "Needs to be fed",
        points: 0,
      },
    ],
  },
  {
    id: 6,
    title: "Cutting food and handling utensils (Patients with gastrostomy)",
    text: "cutting_food_b",
    content: [
      {
        subId: 126,
        subtitle: "Normal",
        points: 4,
      },
      {
        subId: 127,
        subtitle: "Clumsy, but able to perform all manipulations independently",
        points: 3,
      },
      {
        subId: 128,
        subtitle: "Some help needed with closures and fasteners",
        points: 2,
      },
      {
        subId: 129,
        subtitle: "Provides minimal assistance to caregiver",
        points: 1,
      },
      {
        subId: 130,
        subtitle: "Unable to perform any aspect of task",
        points: 0,
      },
    ],
  },
  {
    id: 7,
    title: "Dressing and hygiene",
    text: "dressing_and_hygiene",
    content: [
      {
        subId: 131,
        subtitle: "Normal function",
        points: 4,
      },
      {
        subId: 132,
        subtitle:
          "Independent and complete self-care with effort or decreased efficiency",
        points: 3,
      },
      {
        subId: 133,
        subtitle: "Intermittent assistance or substitute methods",
        points: 2,
      },
      {
        subId: 134,
        subtitle: "Needs attendant for self-care",
        points: 1,
      },
      {
        subId: 135,
        subtitle: "Total dependence",
        points: 0,
      },
    ],
  },

  {
    id: 8,
    title: "Turning in bed and adjusting bed clothes",
    text: "turning_in_bed",
    content: [
      {
        subId: 161,
        subtitle: "Normal function",
        points: 4,
      },
      {
        subId: 162,
        subtitle: "Somewhat slow and clumsy, but no help needed",
        points: 3,
      },
      {
        subId: 163,
        subtitle: "Can turn alone, or adjust sheets, but with great difficulty",
        points: 2,
      },
      {
        subId: 164,
        subtitle: "Can initiate, but not turn or adjust sheets alone",
        points: 1,
      },
      {
        subId: 165,
        subtitle: "Helpless",
        points: 0,
      },
    ],
  },
  {
    id: 9,
    title: "Walking",
    text: "walking",
    content: [
      {
        subId: 136,
        subtitle: "Normal",
        points: 4,
      },
      {
        subId: 137,
        subtitle: "Early ambulation difficulties",
        points: 3,
      },
      {
        subId: 138,
        subtitle: "Walks with assistance",
        points: 2,
      },
      {
        subId: 139,
        subtitle: "Non-ambulatory functional movement",
        points: 1,
      },
      {
        subId: 140,
        subtitle: "No purposeful leg movement",
        points: 0,
      },
    ],
  },
  {
    id: 10,
    title: "Climbing Stairs",
    text: "climbing_stairs",
    content: [
      {
        subId: 141,
        subtitle: "Normal",
        points: 4,
      },
      {
        subId: 142,
        subtitle: "Slow",
        points: 3,
      },
      {
        subId: 143,
        subtitle: "Mild unsteadiness or fatigue",
        points: 2,
      },
      {
        subId: 144,
        subtitle: "Needs assistance",
        points: 1,
      },
      {
        subId: 145,
        subtitle: "Cannot do",
        points: 0,
      },
    ],
  },
  {
    id: 11,
    title: "Dyspnea",
    text: "dyspnea",
    content: [
      {
        subId: 146,
        subtitle: "None",
        points: 4,
      },
      {
        subId: 147,
        subtitle: "Occurs when walking",
        points: 3,
      },
      {
        subId: 148,
        subtitle:
          "Occurs with one or more of the following: eating, bathing, dressing (ADL)",
        points: 2,
      },
      {
        subId: 149,
        subtitle:
          "Occurs at rest: difficulty breathing when either sitting or lying",
        points: 1,
      },
      {
        subId: 150,
        subtitle:
          "Significant difficulty: considering using mechanical respiratory support",
        points: 0,
      },
    ],
  },
  {
    id: 12,
    title: "Orthopnea",
    text: "orthopnea",
    content: [
      {
        subId: 151,
        subtitle: "None",
        points: 4,
      },
      {
        subId: 152,
        subtitle:
          "Some difficulty sleeping at night due to shortness of breath, does not routinely use more than two pillows",
        points: 3,
      },
      {
        subId: 153,
        subtitle: "Needs extra pillows in order to sleep (more than two)",
        points: 2,
      },
      {
        subId: 154,
        subtitle: "Can only sleep sitting up",
        points: 1,
      },
      {
        subId: 155,
        subtitle: "Unable to sleep without mechanical assistance",
        points: 0,
      },
    ],
  },
  {
    id: 13,
    title: "Respiratory Insufficiency",
    text: "respiratory_insufficiency",
    content: [
      {
        subId: 156,
        subtitle: "None",
        points: 4,
      },
      {
        subId: 157,
        subtitle: "Intermittent use of BiPAP",
        points: 3,
      },
      {
        subId: 158,
        subtitle: "Continuous use of BiPAP during the night",
        points: 2,
      },
      {
        subId: 159,
        subtitle: "Continuous use of BiPAP during day & night",
        points: 1,
      },
      {
        subId: 160,
        subtitle:
          "Invasive mechanical ventilation by intubation or tracheostomy",
        points: 0,
      },
    ],
  },
];
export const url = window.location.href;
// Local development/QA override: set REACT_APP_RESEARCH_TYPE_OVERRIDE in the
// gitignored .env to force a study on localhost, e.g. "modality.ai" for Speech.
// Production builds do not set this, so detection falls back to the URL hostname.
export const RESEARCH_TYPE =
  process.env.REACT_APP_RESEARCH_TYPE_OVERRIDE ||
  (url.includes("asymptomatic")
    ? "Asymptomatic Study"
    : url.includes("speech")
      ? "modality.ai"
      : url.includes("lestudy")
        ? "LE Study"
        : "ECAS Study");

export const ECAS_NEW_CONSENT_FORM_EFFECTIVE_DATE = "2026-03-27";
export const LE_STUDY_NEW_CONSENT_FORM_EFFECTIVE_DATE = "2026-05-26";

const LE_STUDY_CONSENT_ASSETS_BASE =
  "https://eals-studentdashboard-assets.s3.us-west-1.amazonaws.com";

/** LE Study consent PDF URLs (S3) — new vs legacy (R16) by language */
export const LE_STUDY_CONSENT_FORM_URLS = {
  newEnglish: `${LE_STUDY_CONSENT_ASSETS_BASE}/LE_Consent_English_June2026.pdf#toolbar=0`,
  legacyEnglish: `${LE_STUDY_CONSENT_ASSETS_BASE}/R16_English+ICF.docx.pdf#toolbar=0`,
  newSpanish: `${LE_STUDY_CONSENT_ASSETS_BASE}/LE_Consent_Spanish_June2026.pdf#toolbar=0`,
  legacySpanish: `${LE_STUDY_CONSENT_ASSETS_BASE}/R16_ICF+Spanish.pdf#toolbar=0`,
};

/** ECAS account creation & aligned portals — `site` select values */
export const ECAS_STUDY_SITE_OPTIONS = [
  "Nova Southeastern University (NSU)",
  "New York University (NYU)",
  "Temple University",
];

// export const RESEARCH_TYPE = "modality.ai";

export const ECAS_FORM_TYPES = ["Form A", "Form B", "Form C"];

export const speech_demographics_form_type = {
  consent_form: "consent_form",
  non_als_user: "non_als_user",
  date_of_birth_and_sex: "date_of_birth_and_sex",
  ethnicity_and_race: "ethnicity_and_race",
  language_and_education: "language_and_education",
  handness_and_smoking_history: "handness_and_smoking_history",
  allergies_and_presriptions: "allergies_and_presriptions",
  medical_history: "medical_history",
  diagnosis: "diagnosis",
  symptom_onset: "symptom_onset",
  family_history: "family_history",
  voice_recording: "voice_recording",
};

export const le_study_demographics_form_type = {
  consent_form: "consent_form",
  date_of_birth_and_sex: "date_of_birth_and_sex",
  ethnicity_and_race: "ethnicity_and_race",
  language_and_education: "language_and_education",
  medical_history: "medical_history",
  symptom_onset: "symptom_onset",
};

export const speech_consent_form_content = [
  "Sponsor: Peter Cohen Foundation (PCF)",
  "City and State: Seattle, WA",
  "Protocol Number and Title: 2021-08-PLAT-P42; Patient-facing Platform for Data Capture from People with Amyotrophic Lateral Sclerosis, Related Neuromuscular Diseases, and Related Dementias",
  "Principal Investigators: Indu Navar Bingham, MS Aria Anvar MD, MBA, ABFM, CFPC",
  "Address of Study Site(s): Peter Cohen Foundation (PCF) – Online 1000 15th Ave East Seattle, WA 98112",

  "24-Hour Telephone Number: 650-799-6342",
  "Invitation to be Part of a Research Study",
  "You are invited to be part of a research study. This consent form will help you choose whether to participate in the study. Feel free to ask if anything is not clear in this consent form. Participation in this study is voluntary. Even if you decide to join now, you can change your mind later.",
  "You must be honest and complete in providing your medical history.",
  "Important Information about this Research Study",
  "Things you should know:",
  "-- The purpose of the study is to create a patient-facing platform to capture high-quality data of patient-reported outcomes and functional data to advance research and improve our understanding of Amyotrophic Lateral Sclerosis (ALS), Related Neuromuscular Diseases, and Related Dementias.",
  "-- In order to participate, you must be 18 years or older and an English speaker.",

  "-- If you choose to participate, you will be asked to register with the Platform, generate a platform-related NeuroSTAmP™, capture some information about you and your condition, and qualify for participation in research studies available on the platform and all future studies, for which you are eligible to participate based on the information you entered and the studies' eligibility criteria.",

  "-- Although this study will not provide intervention direct benefit to you, we will provide the option for you to have a data dashboard of your data, and also it has both scientific and societal benefit. This high-quality, larger dataset modeling will potentially improve current understanding of ALS phenotypes and disease progression, which may improve current clinical care procedures and overall quality of life.",

  "-- The risks involved in this study are minimal and not greater than everyday life. You may find it burdensome, physically and/or emotionally, to be entering data or describing your physical condition or disease outcomes.",

  "-- Taking part in this research study is voluntary. You do not have to participate, and you can stop at any time.",

  "More detailed information is described later in this form. Please take time to read this entire form and ask questions before deciding whether to take part in this research study.",

  "1. What is the study and why are we doing this?",
  "The purpose of this study is to create 'Patient-facing Platform for Data Capture from People with Amyotrophic Lateral Sclerosis, Related Neuromuscular Diseases, and Related Dementias' (the Platform), a pre-competitive, patient-centric, research-driven learning platform designed and developed to support a number of cross-sectional and longitudinal studies and to generate sharable data lodged in a common data repository.",

  "This unique platform facilitates the capture, curation, visualization, aggregation, analyses, storage, and distribution of research data from multiple simultaneously running studies.",

  "Successful implementation of this project will (1) Improve our understanding of the disease and patient phenotypes (2) Result in the development of software tools and novel digital biomarkers that can improve early detection and prognostic accuracy (3) Address the critical need for objective outcome measures for ongoing experimental drug trials.",

  "Who can join this study",
  "People with ALS, PLS, MND, related neuromuscular diseases, related dementias, aymptomatic carriers, blood relatives and non-blood related as controls may join. We plan to enroll all volunteers who would be interested in participating and qualify based on the eligibility criteria.",

  "2. What will happen if you join this study?",

  "If you agree to be in this study, firstly, you will be asked to sign this consent form. Secondly, once consent is made, you will be able to register with the Platform, generate a platform-related NeuroSTAmP, capture baseline information, and qualify for participation in research studies available on the platform at that time and for which you are eligible based on the information you entered and studies eligibility criteria.",

  "You will be asked to use a smartphone or computer to access the Platform and will be prompted to fill out surveys, capture clinical and phenotypical data, and perform on-screen exercises and clinical assessments (e.g., ALSFRS-R or ROADS).",

  "Please note that the platform will not offer any treatment or clinical recommendations.",

  "3. How long and how many people in the study?",

  "The study will seek to enroll up to 100,000 research participants into this community-based platform.",

  "You have the right to withdraw from this study at any time for any reason, without penalty.",

  "4. What are the risks or discomforts might you experience?",

  `There may be a minimal discomfort associated with your enrollment into this study.
You may find it burdensome, physically and/or emotionally, to be entering data or describing your physical condition or disease outcomes.`,

  "Some of the questions or outcome measures may make you feel sad, upset, or frustrated about how ALS has changed your physical or mental state and has affected your quality of life. You may also get tired or bored while participating in the platform's activities. You do not have to answer any question or perform any exercise you do not want to.",

  "Every effort will be made to keep your information confidential. Your data will only be shared with external researchers as a de-identified data set and will be labelled using a unique identifier that is not linked to any HIPAA related information.",

  "5. Are there benefits to being in the study?",
  "Although this study will not provide intervention direct benefit to you, we will provide the option for you to see data dashboard with access you your own data, and additionally it has both scientific and societal benefit. This high-quality, larger dataset modeling will potentially improve current understanding of ALS phenotypes and disease progression, which may improve current clinical care procedures and overall quality of life.",

  "6. What happens to data that are collected in the study?",
  "The data collected in this study are intended for research purposes only. It is then de-identified and stored on our secure, password protected servers.",
  "7. How will we protect your information?",
  "As part of your participation in the study, after you complete the online enrollment form, a unique participant identifier (NeuroSTAmP) will be assigned to you that will allow researchers to see if you have been involved in more than one research study or database for patients with ALS.",
  "If you have participated in more than one study or database, this NeuroSTAmP will help connect information across studies and also allow your de-identified data to be combined with data from other research studies to increase the likelihood of meaningful analyses.",
  "This NeuroSTAmP will be the only identifier connected to your data we share. It will not contain any information about your identity. Your name and any other identifiable information that could potentially identify you will be stored separately from the data collected as a part of this project. Only this NeuroSTAmP and not your personal identifiable information will be accessible to other investigators.",
  "We will share the de-identified data for research under the Data Use Agreement (DUA) that prohibits anyone from trying to identify you. To protect your privacy, we will not include any information that could directly identify you like your name and other personal information, but there is a chance you could be identified despite our best efforts. Your data will be shared and reviewed by not only machines but human beings such as qualified researchers.",
  "If you are not comfortable with the use of your data in future research, you may not want to participate in this study.",
  "8. What will happen to the information we collect about you after the study is over?",
  "We will keep your research data to use for future research. Your name and other information that can directly identify you will be kept secure and stored separately from the research data collected as part of the project. Your Authorization for the collection, use, and sharing of your information does not expire. Additionally, you agree that your information may be used for similar or related future research studies.",
  "9. What if we learn something about your health that you did not know?",
  "As part of this study, we may learn medically relevant information about you. If we learn something that you and your doctor did not know, we will notify you as soon as we can. Only with your permission, we will also notify your doctor, if we know your doctor's contact information.",
  "Again, please note that this study is designed only for the collection of data of patients with ALS, PLS, MND, related neuromuscular diseases, related dementias. It is not a meant to diagnose or treat ALS, related neuromuscular diseases, related dementias.",
  "10. Will it cost you anything to be in this study?",
  "There will be no cost to you to participate in this study.",
  "11. Will you be paid if you join this study?",
  "You will not be paid to participate in this study at this time, we might change this in the future.",
  "The study doctors are being paid by the sponsor to conduct this research.",
  "12. What are your options if you do not want to be in the study?",
  "You do not have to join this study.",
  "13. Your Participation in this Study is Voluntary",
  "It is totally up to you to decide to be in this research study. Participating in this study is voluntary. You will not lose any benefits or rights you already had if you decide not to participate. Even if you decide to be part of the study now, you may change your mind and stop at any time. You do not have to answer any questions you do not want to answer.",
  "You may be withdrawn from the study at any time, by the study investigator, sponsor or Salus IRB, without your consent, for any of the following reasons:",
  "-- to protect your safety/health;",
  "-- if you do not follow the instructions of the study staff;",
  "-- if there are not enough volunteers enrolled/participating in the study;",
  "-- if the sponsor chooses to halt the study.",
  "14. Can you leave the study early?",
  "You may change your mind and cancel this Authorization at any time. If you cancel, you must contact the Principal Investigator in writing to let them know by using the contact information provided in this consent form. Your cancellation will not affect information already collected in the study, or information that has already been shared with others before you cancelled your authorization.",

  "If you leave the study early, Peter Cohen Foundation may use or share your information that it has already collected if the information is needed for this study or any follow-up activities. If you decide to withdraw before the whole protocol is completed, we will keep data that have been collected.",

  "15. Confidentiality",
  "Records of you being in this study will be kept private. There may be times when the study investigator will not be able to guarantee privacy, such as when the study records are requested by a court of law. If information from this study is published or presented at scientific meetings, your name and other personal information will not be used. The following people will have access to study records:",
  "-- Study Investigator and staff;",
  "-- Researchers with whom we share data and who sign the Data Sharing Agreement;",
  "-- Salus IRB",
  "Salus IRB and accrediting agencies may inspect and copy study findings, including this document, which may have your name on them. Therefore, your total privacy cannot be guaranteed.",
  "16. What is the Independent Review Board (IRB) and how does it protect you?",
  "Salus IRB has approved this study and this informed consent document. Salus IRB is a committee of scientific and non-scientific individuals who review, require modifications to, and approve or disapprove research studies by following the federal laws. This group is also required by the federal regulations to provide periodic review of ongoing research studies.",
  "17. Contact Information for the Study Team",
  "If you have any questions, concerns, or complaints about this research, you may contact the Principal Investigators at the phone number listed on page one of the consent document or by email indu@everythingals.org.",
  "18. Contact Information for Questions about Your Rights as a Research Participant",
  "You may contact Salus IRB if you:",
  "-- would like to speak with someone unrelated to the research,",
  "-- have questions, concerns, or complaints regarding the research study, or",
  "-- have questions about your rights as a research participant.",
  "Salus IRB",
  "2111 West Braker Lane, Suite 100",
  "Austin, TX 78758",
  "Phone: 855-300-0815 between 8:00 AM and 5:00 PM Central Time",
  "Email: salus@salusirb.com",
  "If you would like additional information about your rights, research in general, or IRBs, you may visit www.salusirb.com.",
  "19. What does your signature on this consent form mean?",
  "By signing this form, you give permission to the research team to share your information with others outside of Peter Cohen Foundation. This may include the other institutions, researchers, outside providers, study safety monitors, government agencies, other sites in the study, data managers and other agents and contractors used by the study team.",
  "By signing this document, you are agreeing to be in this study. We will give you a copy of this document for your records. We will keep a copy with the study records. If you have any questions about the study after you sign this document, you can contact the study team using the information provided above.",
  "I understand what the study is about, and my questions so far have been answered. I agree to take part in this study.",
];

export const speech_voice_recording_content_part_1 = [
  "Sponsor: Peter Cohen Foundation (PCF)",

  "City and State: Seattle, WA",

  "Protocol Number and Title: 2020-06-PI42; Create a high-quality database of speech and functional data for Amyotrophic Lateral Sclerosis, Related Neuromuscular Diseases and Related Dementias",

  "Principal Investigators: Aria Anvar, MD, MBA, Indu Navar Bingham, MS",
  "Address of Study Site(s): Peter Cohen Foundation (PCF) – Online 1000 15th Ave East Seattle, WA 98112",
  "24-Hour Telephone Number: 650-799-6342",
  "Invitation to be Part of a Research Study",
  "You are invited to be part of a research study. This consent form will help you choose whether or not to participate in the study. Feel free to ask if anything is not clear in this consent form. Participation in this study is voluntary. Even if you decide to join now, you can change your mind later.",
  "You must be honest and complete in providing your medical history.",
  "Important Information about this Research Study",

  "You are invited to be part of a research study. This consent form will help you choose whether or not to participate in the study. Feel free to ask if anything is not clear in this consent form. Participation in this study is voluntary. Even if you decide to join now, you can change your mind later.",

  "You must be honest and complete in providing your medical history.",

  "Important Information about this Research Study",

  "Things you should know:",

  "-- The purpose of the study is to create a high-quality database of speech and functional data collected through a web-based system to advance research for diagnosis of ALS, the disease progression and develop better voice recognition tools to improve the quality of life for the patients.",

  "-- In order to participate, you must be 18 years or older and an English speaker.",

  "-- If you choose to participate, you will be asked to perform audio and video recordings at home or in a comfortable setting of your choice once a week through a web browser on your computer, tablet or smartphone. Each session takes about 20 minutes. There is no direct benefit for participating in this study. The benefit would be to enhance technology tools that will allow for better measurement of ALS disease progression and ultimately improve the quality of life for people with ALS.",

  "-- The risks involved in this study are minimal and not greater than everyday life. Risks or discomforts from this research include boredom because your tasks will be reading simple phrases and simple sounds.",

  "-- Taking part in this research study is voluntary. You do not have to participate, and you can stop at any time.",

  "More detailed information is described later in this form. Please take time to read this entire form and ask questions before deciding whether to take part in this research study.",

  '"1. What is the study and why are we doing this?"',

  "The purpose of this study is to create a high-quality database of speech and functional data from people diagnosed with Amyotrophic Lateral Sclerosis (ALS) to advance research and improve our understanding of this illness. This research may improve early detection and prognostic accuracy, and aid in the development of an oral communication device for persons with a moderate to severe speech impairment.",

  "We are currently collecting audio and video data to help with research to identify symptoms of ALS, signs of disease progression, and to train a computational model that can synthesize speech from speech data. The data will advance current scientific knowledge by helping better understand the change in speech production due to a declining motor system and by showing the feasibility of applying our current synthesized speech models to disordered populations.",

  "If successful, this research may: (1) Foster development of better voice recognition tools to improve quality of life and diagnosis. (2) Result in the development of a software that can improve early detection and prognostic accuracy (3) Address the critical need for objective outcome measures for this disease for ongoing experimental drug trials.",

  '"Who can join this study"',

  "People with ALS, related neuromuscular diseases and healthy controls may join. We plan to enroll many subjects who would be interested in participating.",

  '"2. What will happen if you join this study?"',

  "If you agree to be in this study, firstly, you will be asked to sign this consent form. Secondly, you will be asked to use a computer or smartphone to make a video-call with an automated system in which your facial movements and speech will be recorded and analyzed. This system is provided by our research partner Modality.ai Inc., which follows US HIPAA health laws to keep your data private and secure; the data will be shared only with our research team.",

  "After acquainting you with the system, you will be invited to do subsequent sessions on a regular basis. The sessions will last about 20 minutes and can be done anywhere you feel comfortable, including your own home.",

  "During the video call, you will be asked to complete a questionnaire with 12 questions about your speech and motor status in life (ALSFRS-r or ROADS) and then read aloud a few speech sounds (e.g.,/ah/) and short sentences on the screen.",

  "We recommend you finish this procedure once every week, but it is definitely fine to do more or less often. For example, once every other week is totally acceptable.",
];
export const speech_voice_recording_content_part_2 = [
  "3. How long and how many people in the study?",

  "The study will seek to enroll up to 1,000 subjects with ALS and healthy controls within the 12 months.",

  "Each session of Study with online audio/video recording will take approximately 20 minutes. You are welcome to complete as many sessions as you want, although you are encouraged to do the session once a week.",

  "You have the right to withdraw from this study at any time for any reason, without penalty.",

  "4. What are the risks or discomforts might you experience?",

  "There is a minimal discomfort associated with the procedure. You may get tired or bored when we are asking you questions or you are completing the survey. You do not have to answer any question you do not want to answer. You may find it physically and/or emotionally burdensome to fill out the survey, record your voice using this app.",

  "Completing the on-screen exercises may make you feel sad, upset or frustrated about how your condition has changed or how well you can perform daily activities and how it has affected your quality of life.",

  "Every effort will be made to keep your information confidential. Your audio/video and any data will only be shared as a de-identified data set and will be labelled using a unique code that is not linked to any HIPAA related information.",

  "5. Are there benefits to being in the study?",

  "There will not be a direct benefit from participating in this study; however you will get analysis of the progression of your voice words per minute analysis each time you record your voice. This research data collected may advance the understanding of the diagnosis and prognosis of ALS and may also contribute to the future treatments and technology used to assist with speech communication of patients with speech impairments.",

  "6. What happens to data that are collected in the study?",

  "As part of the study we will collect audio and video data from you while you read simple sounds, words and phrases. It is then de-identified and stored on our secure, password protected servers.",

  "7. How will we protect your information?",

  "As part of your participation in the study, a unique subject identifier will be assigned to you that will allow researchers to see if you have been involved in more than one research study or database for patients with ALS. If you have participated in more than one study or database, this unique subject identifier will help connect information across studies.",

  "This subject identifier will also allow your de-identified data to be combined with data from other research studies to increase the likelihood of meaningful analysis. Only this subject identifier and not your personal identifiable information will be accessible to other investigators. This unique subject identifier may make it possible for a study doctor who used this unique subject identifier in another study that you took part in to identify you.",

  "When you complete the online enrollment form, you will be assigned a unique subject identifier. This number will be the only thing connected to your data we share. It will not contain any information about your identity. Your name and any other identifiable information that could potentially identify you will be stored separately from the data collected as a part of this project.",

  "Peter Cohen Foundation and our research partners work to advance science. The data we collect about you are important to this effort. We will share the de-identified data for research under the Data Use Agreement (DUA) that prohibits anyone from trying to identify you.",

  "To protect your privacy, we will not include any information that could directly identify you like your name and other personal information but sharing includes audio and video files so therefore there is a chance they could be identified despite our best efforts. Your video and audio data will be shared and reviewed by not only machines but human beings such as qualified researchers who will have access to both the voice and the video, from which you could potentially be recognized.",

  "Data sharing could change over time, and may continue after the study ends.",
  "If you are not comfortable with the use of your data in future research, you may not want to participate in this study.",

  "We will keep your research data to use for future research. Your name and other information that can directly identify you will be kept secure and stored separately from the research data collected as part of the project. Your Authorization for the collection, use, and sharing of your information does not expire. Additionally, you agree that your information may be used for similar or related future research studies.",

  "9. What if we learn something about your health that you did not know?",

  "As part of this study, we may learn medically relevant information about you. If we learn something that you and your doctor did not know, we will notify you as soon as we can. With your permission, we will also notify your doctor, if we know your doctor's contact information. Again, please note that this study is designed only for the collection of speech and facial data of patients with ALS. It is not a meant to diagnose or treat ALS.",

  "10. Will it cost you anything to be in this study?",
  "There will be no cost to you to participate in this study.",

  "11. Will you be paid if you join this study?",
  "You will not be paid to participate in this study.",

  "12. What are your options if you do not want to be in the study?",
  "You do not have to join this study. The study doctors are being paid by the sponsor to conduct this research study.",

  "13. Your Participation in this Study is Voluntary",

  "It is totally up to you to decide to be in this research study. Participating in this study is voluntary. You will not lose any benefits or rights you already had if you decide not to participate. Even if you decide to be part of the study now, you may change your mind and stop at any time. You do not have to answer any questions you do not want to answer.",

  "You may be withdrawn from the study at any time, by the study investigator, sponsor or Salus IRB, without your consent, for any of the following reasons:",

  "-- to protect your safety/health",

  "-- if you do not follow the instructions of the study staff",

  "-- if there are not enough volunteers enrolled/participating in the study",

  "-- if the sponsor chooses to halt the study",

  "14. Can you leave the study early?",

  "You may change your mind and cancel this Authorization at any time. If you cancel, you must contact the Principal Investigator in writing to let them know by using the contact information provided in this consent form. Your cancellation will not affect information already collected in the study, or information that has already been shared with others before you cancelled your authorization.",

  "If you leave the study early, Peter Cohen Foundation may use or share your information that it has already collected if the information is needed for this study or any follow-up activities. If you decide to withdraw before the whole protocol is completed, we will keep data that have been collected.",

  "15. Confidentiality",

  "Records of you being in this study will be kept private. There may be times when the study investigator will not be able to guarantee privacy, such as when the study records are requested by a court of law. If information from this study is published or presented at scientific meetings, your name and other personal information will not be used. The following people will have access to study records:",

  "-- Study Investigator and staff;",

  "-- Sponsor Company or its designees;",

  "-- Salus IRB",

  "Salus IRB and accrediting agencies may inspect and copy study findings, including this document, which may have your name on them. Therefore, your total privacy cannot be guaranteed.",

  "16. What is the Independent Review Board (IRB) and how does it protect you?",

  "Salus IRB has approved this study and this informed consent document. Salus IRB is a committee of scientific and non-scientific individuals who review, require modifications to, and approve or disapprove research studies by following the federal laws. This group is also required by the federal regulations to provide periodic review of ongoing research studies.",

  "17. Contact Information for the Study Team",

  "If you have any questions, concerns, or complaints about this research, you may contact:",

  "Principal Investigators: Aria Anvar, MD, MBA Email: info@everythingals.org And Indu Navar Bingham, MS Email: speech@everythingals.org",

  "18. Contact Information for Questions about Your Rights as a Research Participant",

  "You may contact Salus IRB if you:",

  "-- would like to speak with someone unrelated to the research,",

  "-- have questions, concerns, or complaints regarding the research study, or",

  "-- have questions about your rights as a research participant.",

  "Salus IRB",

  "2111 West Braker Lane, Suite 100",

  "Austin, TX 78758",

  "Phone: 855-300-0815 between 8:00 AM and 5:00 PM Central Time",

  "Email: salus@salusirb.com",

  "If you would like additional information about your rights, research in general, or",
  "IRBs, you may visit www.salusirb.com.",

  "19. What does your signature on this consent form mean?",

  "By signing this form, you give permission to the research team to share your information with others outside of Peter Cohen Foundation. This may include the other institutions, researchers, outside providers, study safety monitors, government agencies, other sites in the study, data managers and other agents and contractors used by the study team.",

  "By signing this document, you are agreeing to be in this study. We will give you a copy of this document for your records. We will keep a copy with the study records. If you have any questions about the study after you sign this document, you can contact the study team using the information provided above.",

  "I understand what the study is about and my questions so far have been answered. I agree to take part in this study.",
];
export const COUNTRY_LIST = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",

  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",

  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo, (Congo-Brazzaville)",
  "Costa Rica",
  "Côte d'Ivoire",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",

  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",

  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",

  "Fiji",
  "Finland",
  "France",

  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",

  "Haiti",
  "Honduras",
  "Hungary",

  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",

  "Jamaica",
  "Japan",
  "Jordan",

  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",

  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",

  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar (Burma)",

  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "North Macedonia",
  "Norway",

  "Oman",

  "Pakistan",
  "Palau",
  "Palestine",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",

  "Qatar",

  "Romania",
  "Russia",
  "Rwanda",

  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",

  "Taiwan",
  "Tajikistan",
  "Tania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",

  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "Uruguay",
  "Uzbekistan",

  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",

  "Yemen",

  "Zambia",
  "Zimbabwe",
];

export const CURRENT_RESIDENCE_COUNTRY_OPTIONS = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
  "Other US Territory",
];
export const JOURNEY_LIST = [
  "I HAVE confirmed ALS or other neurological disease diagnosis",
  "I SUSPECT to have ALS or other neurological symptoms",
  "I DO NOT have neurological symptoms",
];
export const RACE_OPTIONS_ECAS = [
  "White",
  "Black or African American ",
  "American Indian or Alaska Native",
  "Asian Indian",
  "Chinese",
  "Filipino",
  "Japanese",
  "Korean",
  "Vietnamese",
  "Other Asian",
  "Native Hawaiian",
  "Other Pacific Islander",
  "Unknown",
  "Other",
  "Decline to answer",
];
export const ETHNICITY_OPTIONS_ECAS = [
  "Not of Hispanic, Latino/a or Spanish origin ",
  "Mexican, Mexican American, Chicano/a",
  "Puerto Rican",
  "Cuban",
  "Another Hispanic Latino/a or Spanish origin",
  "Other",
  "Decline to answer",
];
export const RECEIVED_THEROPHY_LIST = [
  "Hearing impaired / wear a hearing aid",
  "Vision impaired / wear glasses",
  "Currently wearing a dental appliance or dentures",
  "None of the above",
];
export const I_KNOW_MY_ALS_GENE_LIST = [
  "ALS2",
  "ANXA11",
  "ATXN2",
  "C9orf72",
  "CHCHD10",
  "CHMP2B",
  "DCTN1",
  "DNAJC7",
  "FUS",
  "GLE1",
  "KIF5A",
  "MATR3",
  "NEK1",
  "OPTN",
  "PFN1",
  "SETX",
  "SIGMAR1",
  "SOD1",
  "SPG11",
  "SPTLC1",
  "SPTLC2",
  "SQSTM1",
  "TARDBP",
  "TBK1",
  "TUBA4A",
  "UBQLN2",
  "UNC13A",
  "VAPB",
  "VCP",
];
export const GENE_MUTATION_YES_OPTIONS = [
  "I have tested positive for an ALS and/or FTD related mutation",
  "I have tested negative for the ALS and/or FTD mutation that is present within my family",
  "My family currently doesn’t know of a specific genetic mutation causative of ALS and/org FTD and I was told I tested negative",
  "I recently submitted my genetic test and have not yest received results",
  "I have undergone genetic testing as an observational study participant but have decided to remain blinded for the results",
];
export const NON_ALS_MND_OPTIONS = [
  "Primary Lateral Sclerosis (PLS)",
  "Progressive Muscular Atrophy (PMA)",
  "Progressive Bulbar Palsy (PBP)",
  "Progressive Supranuclear Palsy (PSP)",
  "VCP Disease (Valosin-Containing Protein Disease)",
  "Fronto-Temporal Dementia (non-ALS-related)",
  "Alzheimer’s Disease",
  "Dementia with Lewy Bodies (DLB)",
  "Muscular Diseases (e.g., Myasthenia Gravis, Muscular Dystrophy)",
  "Parkinson’s Disease or Parkinsonism",
  "Multiple Sclerosis (MS)",
  "Other",
];
export const SITE_OF_SYMPTOM_ONSET_LIST = [
  "Generalized",
  "Bulbar",
  "Neck weakness",
  "Trunk weakness",
  "Respiratory",
  "Limb",
  "Other site of symptoms",
];
export const SITE_OF_SYMPTOM_ONSET_LIMB_LIST = [
  "Upper right hand/finger",
  "Upper right Arm",
  "Upper left hand/finger",
  "Upper left Arm",
  "Lower right ankle/foot/toes",
  "Lower right leg",
  "Lower left ankle/foot/toes",
  "Lower left leg",
];
export const SITE_OF_SYMPTOM_ONSET_BULBAR_LIST = ["Speech", "Swallowing"];
export const APPLIES_TO_YOU_LIST = [
  "I have no neurological symptoms",
  "I am an Asymptomatic gene carrier",
  "I am confirmed ALS reversal (from Dr. Richard Bedlack or Other Neurologist)",
];
export const REVERSAL_DOCUMENTATION_LIST = [
  "From Dr. Richard Bedlack’s",
  "Other",
];
export const NON_BLOOD_RELATIVES = [
  "Spouse or Partner",
  "Friends (age-matched controls)",
  "Students or Young Adults (healthy younger population)",
  "Other",
  "N/A",
];
export const BLOOD_RELATIVE_LIST = [
  "Children",
  "Siblings",
  "Parents",
  "Other relative",
];
export const US_STATES = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
  "Other US Territory",
  "District of Columbia",
];

export const LE_STUDY_ETHNICITY_OPTIONS = [
  {
    label: 'American Indian or Alaska Native',
  },
  {
    label: 'Asian',
  },
  {
    label: 'Black or African American',
  },
  {
    label: 'Native Hawaiian or Other Pacific Islander',
  },
  {
    label: 'White',
  },
  {
    label: 'Other',
  },
  {
    label: 'Prefer not to answer',
  },
];
export const LE_STUDY_DEMOGRAPHICS_GENDER_OPTIONS = [
  {
    label: "Male",
    value: "Male",
  },
  {
    label: "Female",
    value: "Female",
  },
  {
    label: "Prefer not to say",
    value: "Prefer not to say",
  },
  {
    label: "Other",
    value: "Other",
  },
];
export const LE_STUDY_DEMOGRAPHICS_GENDER_OPTIONS_OLD = [
  {
    label: 'Male',
    value: 'Male',
  },
  {
    label: 'Female',
    value: 'Female',
  },
  {
    label: 'Transgender Male/Trans Man/Female-to-Male (FTM)',
    value: 'Transgender Male/Trans Man/Female-to-Male (FTM)',
  },
  {
    label: 'Transgender Female/Trans Woman/Male-to-Female (MTF)',
    value: 'Transgender Female/Trans Woman/Male-to-Female (MTF)',
  },
  {
    label: 'Genderqueer/Gender-Non-Conforming',
    value: 'Genderqueer/Gender-Non-Conforming',
  },
  {
    label: 'Non-Binary',
    value: 'Non-Binary',
  },
  {
    label: 'Prefer not to say',
    value: 'Prefer not to say',
  },
  {
    label: 'Other',
    value: 'Other',
  },
];
export const LE_STUDY_DEMOGRAPHICS_GENDER_SPANISH_OPTIONS = [
  {
    label: 'Male',
    value: 'Male',
  },
  {
    label: 'Female',
    value: 'Female',
  },
  {
    label: 'Transgender Male/Trans Man/Female-to-Male (FTM)',
    value: 'Transgender Male/Trans Man/Female-to-Male (FTM)',
  },
  {
    label: 'Transgender Female/Trans Woman/Male-to-Female (MTF)',
    value: 'Transgender Female/Trans Woman/Male-to-Female (MTF)',
  },
  {
    label: 'Genderqueer/Gender-Non-Conforming',
    value: 'Genderqueer/Gender-Non-Conforming',
  },
  {
    label: 'Non-Binary',
    value: 'Non-Binary',
  },
  {
    label: 'Prefer not to say',
    value: 'Prefer not to say',
  },
  {
    label: 'Other',
    value: 'Other',
  },
];

export const LE_STUDY_DEMOGRAPHICS_HIGHEST_LEVEL_OF_EDUCATIONS = [
  {
    label: 'No formal education',
  },
  {
    label: 'Elementary school',
  },
  {
    label: 'High school graduate / GED',
  },
  {
    label: 'Some college, no degree',
  },
  {
    label: 'Associate degree, vocational school, or equivalent',
  },
  {
    label: 'Bachelor\'s degree (e.g., BA, BS)',
  },
  {
    label: 'Master\'s degree',
  },
  {
    label: 'Doctorate or Ph.D.',
  },
  {
    label: 'Other',
  },
];
export const LE_STUDY_DEMOGRAPHICS_ALS_DRUG_HISTORY = [
  {
    label: 'Riluzole',
  },
  {
    label: 'Radicava (Edaravone)',
  },
  {
    label: 'High dose B12',
  },
  {
    label: 'Tofersen (Qalsody)',
  },
  {
    label: 'Clene (CNM-Au8)',
  },
  {
    label: 'Prime C (ciprofloxacin/celecoxib)',
  },
  {
    label: 'Nuedexta',
  },
  {
    label: 'Other',
  },
];
export const GENETIC_STATUS_DEMOGRAPHICS_LIST = [
  "ALS2",
  "ANXA11",
  "ATXN2",
  "C9orf72",
  "CHCHD10",
  "CHMP2B",
  "DCTN1",
  "DNAJC7",
  "FUS",
  "GLE1",
  "KIF5A",
  "MATR3",
  "NEK1",
  "OPTN",
  "PFN1",
  "SETX",
  "SIGMAR1",
  "SOD1",
  "SPG11",
  "SPTLC1",
  "SPTLC2",
  "SQSTM1",
  "TARDBP",
  "TBK1",
  "TUBA4A",
  "UBQLN2",
  "UNC13A",
  "VAPB",
  "VCP",
];

export const ECAS_ALSFRS_R_FIELDS = [
  {
    field: "SPEECH_FTORRES",
    options: [
      {
        label: '4 = Normal speech processes',
        value: '4'
      },
      {
        label: '3 = Detectable speech disturbances',
        value: '3'
      },
      {
        label: '2 = Intelligible with repeating',
        value: '2'
      },
      {
        label: '1 = Speech combined with nonvocal communication',
        value: '1'
      },
      {
        label: '0 = Loss of useful speech',
        value: '0'
      }
    ],
    field_label: '1. Speech:',
    view_name: 'v_EALSPE_ALSFRSRLOG',
    state_name: 'speech',
    value: ''
  },
  {
    field: 'SALIVA_FTORRES',
    options: [
      {
        label: "4 = Normal",
        value: "4"
      },
      {
        label: "3 = Slight but definite excess of saliva in mouth; may have nighttime drooling",
        value: "3"
      },
      {
        label: "2 = Moderately excessive saliva; may have minimal drooling",
        value: "2"
      },
      {
        label: "1 = Marked excess of saliva with some drooling",
        value: "1"
      },
      {
        label: "0 = Marked drooling; requires constant tissue or handkerchief",
        value: "0"
      }
    ],
    field_label: "2. Salivation:",
    view_name: "v_EALSPE_ALSFRSRLOG",
    state_name: "salivation",
    value: ''
  },
  {
    field: 'SWALLOW_FTORRES',
    options: [
      {
        label: "4 = Normal eating habits",
        value: "4"
      },
      {
        label: "3 = Early eating problems - occasional choking",
        value: "3"
      },
      {
        label: "2 = Dietary consistency changes",
        value: "2"
      },
      {
        label: "1 = Needs supplemental tube feeding",
        value: "1"
      },
      {
        label: "0 = NPO (exclusively parenteral or enteral feeding)",
        value: "0"
      }
    ],
    field_label: "3. Swallowing:",
    view_name: "v_EALSPE_ALSFRSRLOG",
    state_name: "swallowing",
    value: ''
  },
  {
    field: "HNDWRIT_FTORRES",
    options: [
      {
        label: "4 = Normal",
        value: "4"
      },
      {
        label: "3 = Slow or sloppy; all words are legible",
        value: "3"
      },
      {
        label: "2 = Not all words are legible",
        value: "2"
      },
      {
        label: "1 = Able to grip pen but unable to write",
        value: "1"
      },
      {
        label: "0 = Unable to grip pen",
        value: "0"
      }
    ],
    field_label: "4. Handwriting:",
    view_name: "v_EALSPE_ALSFRSRLOG",
    state_name: "handwriting",
    value: ''
  },
  {
    field: 'GASTRO_FTORRES',
    options: [
      {
        label: "Yes",
        value: "1"
      },
      {
        label: "No",
        value: "2"
      }
    ],
    field_label: "Participant uses a gastrostomy for greater than 50% of nutrition:",
    view_name: "v_EALSPE_ALSFRSRLOG",
    state_name: "participant_uses_gastronomy",
    value: ''
  },
  {
    field: 'UTENWOG_FTORRES',
    options: [
      {
        label: "4 = Normal",
        value: "4"
      },
      {
        label: "3 = Somewhat slow and clumsy, but no help needed",
        value: "3"
      },
      {
        label: "2 = Can cut most foods, although clumsy and slow; some help needed",
        value: "2"
      },
      {
        label: "1 = Food must be cut by someone, but can still feed slowly",
        value: "1"
      },
      {
        label: "0 = Needs to be fed",
        value: "0"
      }
    ],
    field_label: "5a. Cutting Food and Handling Utensils (participants without gastrostomy):",
    view_name: "v_EALSPE_ALSFRSRLOG",
    state_name: "cutting_food_a",
    value: ''
  },
  {
    field: 'UTENWG_FTORRES',
    options: [
      {
        label: "4 = Normal",
        value: "4"
      },
      {
        label: "3 = Clumsy but able to perform all manipulations independently",
        value: "3"
      },
      {
        label: "2 = Some help needed with closures and fasteners",
        value: "2"
      },
      {
        label: "1 = Provides minimal assistance to caregivers",
        value: "1"
      },
      {
        label: "0 = Unable to perform any aspect of task",
        value: "0"
      }
    ],
    field_label: "5b. Cutting Food and Handling Utensils (alternate scale for participants with gastrostomy):",
    view_name: "v_EALSPE_ALSFRSRLOG",
    state_name: "cutting_food_b",
    value: ''
  },
  {
    field: 'HYGIENE_FTORRES',
    options: [
      {
        label: "4 = Normal function",
        value: "4"
      },
      {
        label: "3 = Independent and complete self-care with effort or decreased efficiency",
        value: "3"
      },
      {
        label: "2 = Intermittent assistance or substitute methods",
        value: "2"
      },
      {
        label: "1 = Needs attendant for self-care",
        value: "1"
      },
      {
        label: "0 = Total dependence",
        value: "0"
      }
    ],
    field_label: "6. Dressing and Hygiene:",
    view_name: "v_EALSPE_ALSFRSRLOG",
    state_name: "dressing_and_hygine",
    value: ''
  },
  {
    field: 'BEDCLOTH_FTORRES',
    options: [
      {
        label: "4 = Normal",
        value: "4"
      },
      {
        label: "3 = Somewhat slow and clumsy, but no help needed",
        value: "3"
      },
      {
        label: "2 = Can turn alone or adjust sheets, but with great difficulty",
        value: "2"
      },
      {
        label: "1 = Can initiate, but not turn or adjust sheets alone",
        value: "1"
      },
      {
        label: "0 = Helpless",
        value: "0"
      }
    ],
    field_label: "7. Turning in Bed and Adjusting Bed Clothes:",
    view_name: "v_EALSPE_ALSFRSRLOG",
    state_name: "turning_bed",
    value: ''
  },
  {
    field: 'WALKING_FTORRES',
    options: [
      {
        label: "4 = Normal",
        value: "4"
      },
      {
        label: "3 = Early ambulation difficulties",
        value: "3"
      },
      {
        label: "2 = Walks with assistance",
        value: "2"
      },
      {
        label: "1 = Nonambulatory functional movement only",
        value: "1"
      },
      {
        label: "0 = No purposeful leg movement",
        value: "0"
      }
    ],
    field_label: "8. Walking:",
    view_name: "v_EALSPE_ALSFRSRLOG",
    state_name: "walking",
    value: ''
  },
  {
    field: "STAIRS_FTORRES",
    options: [
      {
        label: "4 = Normal",
        value: "4"
      },
      {
        label: "3 = Slow",
        value: "3"
      },
      {
        label: "2 = Mild unsteadiness or fatigue",
        value: "2"
      },
      {
        label: "1 = Needs assistance",
        value: "1"
      },
      {
        label: "0 = Cannot do",
        value: "0"
      }
    ],
    field_label: "9. Climbing Stairs:",
    view_name: "v_EALSPE_ALSFRSRLOG",
    state_name: "climbing_stairs",
    value: ""
  },
  {
    field: "DYSPNEA_FTORRES",
    options: [
      {
        label: "4 = None",
        value: "4"
      },
      {
        label: "3 = Occurs when walking",
        value: "3"
      },
      {
        label: "2 = Occurs with one or more of the following: eating, bathing, dressing",
        value: "2"
      },
      {
        label: "1 = Occurs at rest, difficulty breathing when either sitting or lying",
        value: "1"
      },
      {
        label: "0 = Significant difficulty, considering using mechanical respiratory support",
        value: "0"
      }
    ],
    field_label: "R-1 Dyspnea:",
    view_name: "v_EALSPE_ALSFRSRLOG",
    state_name: "dyspnea",
    value: ""
  },
  {
    field: "ORTHO_FTORRES",
    options: [
      {
        label: "4 = None",
        value: "4"
      },
      {
        label: "3 = Some difficulty sleeping at night due to shortness of breath, does not routinely use more than two pillows",
        value: "3"
      },
      {
        label: "2 = Needs extra pillow in order to sleep (more than two)",
        value: "2"
      },
      {
        label: "1 = Can only sleep sitting up",
        value: "1"
      },
      {
        label: "0 = Unable to sleep without mechanical assistance",
        value: "0"
      }
    ],
    field_label: "R-2 Orthopnea:",
    view_name: "v_EALSPE_ALSFRSRLOG",
    state_name: "orthopnea",
    value: ""
  },
  {
    field: "RESPINS_FTORRES",
    options: [
      {
        label: "4 = None",
        value: "4"
      },
      {
        label: "3 = Intermittent use of NIPPV",
        value: "3"
      },
      {
        label: "2 = Continuous use of NIPPV during the night",
        value: "2"
      },
      {
        label: "1 = Continuous use of NIPPV during the night and day",
        value: "1"
      },
      {
        label: "0 = Invasive mechanical ventilation by intubation or tracheostomy",
        value: "0"
      }
    ],
    field_label: "R-3 Respiratory Insufficiency:",
    view_name: "v_EALSPE_ALSFRSRLOG",
    state_name: "respiratory_insufficiency",
    value: ""
  }
];

export const ECAS_ALSFRS_R_CUTTING_FOOD_A_OPTIONS = [
  {
    label: "4 = Normal",
    value: "4"
  },
  {
    label: "3 = Somewhat slow and clumsy, but no help needed",
    value: "3"
  },
  {
    label: "2 = Can cut most foods, although clumsy and slow; some help needed",
    value: "2"
  },
  {
    label: "1 = Food must be cut by someone, but can still feed slowly",
    value: "1"
  },
  {
    label: "0 = Needs to be fed",
    value: "0"
  }
];

export const ECAS_ALSFRS_R_CUTTING_FOOD_B_OPTIONS = [
  {
    label: "4 = Normal",
    value: "4"
  },
  {
    label: "3 = Clumsy but able to perform all manipulations independently",
    value: "3"
  },
  {
    label: "2 = Some help needed with closures and fasteners",
    value: "2"
  },
  {
    label: "1 = Provides minimal assistance to caregivers",
    value: "1"
  },
  {
    label: "0 = Unable to perform any aspect of task",
    value: "0"
  }
];
export const LE_STUDY_DEMOGRAPHICS_CONTENT = [
  // Caregiver Status
  {
    id: 1,
    title: 'Caregiver Status',
    field: 'caregiverStatus',
    darkColor: '#FB6C66',
    lightColor: '#FFEEE4',
    content: [
      {
        subId: 101,
        subtitle: 'Single',
      },
      {
        subId: 102,
        subtitle: 'Married',
      },
      {
        subId: 103,
        subtitle: 'Divorced',
      },
      {
        subId: 104,
        subtitle: 'Widowed',
      },
      {
        subId: 105,
        subtitle: 'Living with Partner',
      },
      {
        subId: 106,
        subtitle: 'Prefer not to answer',
      },
    ],
  },
  // Site of Onset
  {
    id: 2,
    title: 'Site of Onset',
    field: 'siteOfOnset',
    darkColor: '#8870E6',
    lightColor: '#F0ECFF',
    content: [
      {
        subId: 201,
        subtitle: 'Swallow',
      },
      {
        subId: 202,
        subtitle: 'Speech',
      },
      {
        subId: 203,
        subtitle: 'Respiratory',
      },
      {
        subId: 204,
        subtitle: 'Leg',
      },
      {
        subId: 205,
        subtitle: 'Arm',
      },
    ],
  },
  // Phenotype
  {
    id: 3,
    title: 'Phenotype',
    field: 'phenotype',
    darkColor: '#44B277',
    lightColor: '#E1F7EC',
    content: [
      {
        subId: 301,
        subtitle: 'Classic',
      },
      {
        subId: 302,
        subtitle: 'Bulbar',
      },
      {
        subId: 303,
        subtitle: 'Flail Arm',
      },
      {
        subId: 304,
        subtitle: 'Flail Leg',
      },
      {
        subId: 305,
        subtitle: 'Pyramidal',
      },
    ],
  },
  // Genetic Status
  {
    id: 4,
    title: 'Genetic Status',
    field: 'geneticStatus',
    darkColor: '#FB6C66',
    lightColor: '#FFEEE4',
    content: [
      {
        subId: 401,
        subtitle: 'Negative',
      },
      {
        subId: 402,
        subtitle: 'Positive',
      },
      {
        subId: 403,
        subtitle: 'Unknown / NA',
      },
    ],
  },
  // Ethnicity
  {
    id: 5,
    title: 'Ethnicity',
    field: 'ethnicity',
    darkColor: '#8870E6',
    lightColor: '#F0ECFF',
    content: [
      {
        subId: 501,
        subtitle: 'Non of Hispanic, Latino(a) or Spanish origin',
      },
      {
        subId: 502,
        subtitle: 'Of Hispanic, Latino(a) or Spanish origin',
      },
      {
        subId: 503,
        subtitle: 'Prefer not to answer',
      },
    ],
  },
  // Race
  {
    id: 6,
    title: 'Race',
    field: 'race',
    darkColor: '#44B277',
    lightColor: '#E1F7EC',
    content: [
      {
        subId: 601,
        subtitle: 'American Indian or Alaska Native',
      },
      {
        subId: 602,
        subtitle: 'Asian',
      },
      {
        subId: 603,
        subtitle: 'Black or African American',
      },
      {
        subId: 604,
        subtitle: 'Native Hawaiian or Other Pacific Islander',
      },
      {
        subId: 605,
        subtitle: 'White',
      },
      {
        subId: 606,
        subtitle: 'Other',
      },
      {
        subId: 607,
        subtitle: 'Prefer not to answer',
      },
    ],
  },
  // Physical sex at birth
  {
    id: 7,
    title: 'Physical sex at birth',
    field: 'physicalSexAtBirth',
    darkColor: '#FB6C66',
    lightColor: '#FFEEE4',
    content: [
      {
        subId: 701,
        subtitle: "Male",
      },
      {
        subId: 702,
        subtitle: "Female",
      },
      {
        subId: 703,
        subtitle: "Prefer not to say",
      },
      {
        subId: 704,
        subtitle: "Other",
      }
    ],
  },
  // gender identity
  {
    id: 26,
    title: "Gender Identity",
    spanishTitle: 'Identidad de género',
    field: "genderIdentity",
    darkColor: "#FB6C66",
    lightColor: "#FFEEE4",
    content: [
      {
        subId: 2601,
        subtitle: "Man",
        spanishSubtitle: 'Hombre',
      },
      {
        subId: 2602,
        subtitle: "Woman",
        spanishSubtitle: 'Mujer',
      },
      {
        subId: 2603,
        subtitle: "Transgender Male/Trans Man/Female-to-Male (FTM)",
        spanishSubtitle: 'Hombre transgénero/Hombre trans/Mujer a hombre (FTM)',
      },
      {
        subId: 2604,
        subtitle: "Transgender Female/Trans Woman/Male-to-Female (MTF)",
        spanishSubtitle: 'Mujer transgénero/Mujer trans/Hombre a mujer (MTF)',
      },
      {
        subId: 2605,
        subtitle: "Genderqueer/Gender Non-Conforming",
        spanishSubtitle: 'Género no binario/Género no conforme',
      },
      {
        subId: 2606,
        subtitle: "Non-binary",
        spanishSubtitle: 'No binario',
      },
      {
        subId: 2607,
        subtitle: "Prefer not to say",
        spanishSubtitle: 'Prefiero no decir',
      },
      {
        subId: 2608,
        subtitle: "Other",
        spanishSubtitle: 'Otro',
      },
    ],
  },
  // What is your first language?
  {
    id: 8,
    title: 'What is your first language?',
    field: 'firstLanguage',
    darkColor: '#8870E6',
    lightColor: '#F0ECFF',
    content: [
      {
        subId: 801,
        subtitle: 'English',
      },
      {
        subId: 802,
        subtitle: 'Spanish',
      },
      {
        subId: 803,
        subtitle: 'Other',
      },
    ],
  },
  // Spanish Literacy
  {
    id: 9,
    title: 'Spanish Literacy',
    field: 'spanishLiteracy',
    darkColor: '#44B277',
    lightColor: '#E1F7EC',
    content: [
      {
        subId: 901,
        subtitle: 'Yes',
      },
      {
        subId: 902,
        subtitle: 'No',
      },
    ],
  },
  // English Literacy
  {
    id: 10,
    title: 'English Literacy',
    field: 'englishLiteracy',
    darkColor: '#FB6C66',
    lightColor: '#FFEEE4',
    content: [
      {
        subId: 1001,
        subtitle: 'Yes',
      },
      {
        subId: 1002,
        subtitle: 'No',
      },
    ],
  },
  // Highest level of education
  {
    id: 11,
    title: 'Highest level of education',
    field: 'educationLevel',
    darkColor: '#8870E6',
    lightColor: '#F0ECFF',
    content: [
      {
        subId: 1101,
        subtitle: 'No formal education',
      },
      {
        subId: 1102,
        subtitle: 'Elementary school',
      },
      {
        subId: 1103,
        subtitle: 'High school graduate / GED',
      },
      {
        subId: 1104,
        subtitle: 'Some college, no degree',
      },
      {
        subId: 1105,
        subtitle: 'Associate degree, vocational school, or equivalent',
      },
      {
        subId: 1106,
        subtitle: 'Bachelor\'s degree (e.g., BA, BS)',
      },
      {
        subId: 1108,
        subtitle: 'Master\'s degree',
      },
      {
        subId: 1109,
        subtitle: 'Doctorate or Ph.D.',
      },
      {
        subId: 1110,
        subtitle: 'Other',
      },
    ],
  },
  // ALS Drug History
  {
    id: 12,
    title: 'ALS Drug History',
    field: 'alsDrugHistory',
    darkColor: '#44B277',
    lightColor: '#E1F7EC',
    content: [
      {
        subId: 1201,
        subtitle: 'Riluzole',
      },
      {
        subId: 1202,
        subtitle: 'Radicava (Edaravone)',
      },
      {
        subId: 1203,
        subtitle: 'High dose B12',
      },
      {
        subId: 1204,
        subtitle: 'Tofersen (Qalsody)',
      },
      {
        subId: 1205,
        subtitle: 'Clene (CNM-Au8)',
      },
      {
        subId: 1206,
        subtitle: 'Prime C (ciprofloxacin/celecoxib)',
      },
      {
        subId: 1207,
        subtitle: 'Nuedexta',
      },
      {
        subId: 1208,
        subtitle: 'Other',
      },
    ],
  },
  // Currently Enrolled in other interventional clinical trials
  {
    id: 13,
    title: 'Currently Enrolled in other interventional clinical trials',
    field: 'currentlyEnrolledInOtherTrials',
    darkColor: '#FB6C66',
    lightColor: '#FFEEE4',
    content: [
      {
        subId: 1301,
        subtitle: 'Yes',
      },
      {
        subId: 1302,
        subtitle: 'No',
      },
    ],
  },
  // HC Medical History - Neurological disease
  {
    id: 14,
    title: 'Neurological disease',
    field: 'neurologicalDisease',
    darkColor: '#8870E6',
    lightColor: '#F0ECFF',
    content: [
      {
        subId: 1401,
        subtitle: 'Yes',
      },
      {
        subId: 1402,
        subtitle: 'No',
      },
    ],
  },
  // HC Medical History - Stroke
  {
    id: 15,
    title: 'Stroke',
    field: 'stroke',
    darkColor: '#44B277',
    lightColor: '#E1F7EC',
    content: [
      {
        subId: 1501,
        subtitle: 'Yes',
      },
      {
        subId: 1502,
        subtitle: 'No',
      },
    ],
  },
  // HC Medical History - Traumatic Brain Injury
  {
    id: 16,
    title: 'Traumatic Brain Injury',
    field: 'traumaticBrainInjury',
    darkColor: '#FB6C66',
    lightColor: '#FFEEE4',
    content: [
      {
        subId: 1601,
        subtitle: 'Yes',
      },
      {
        subId: 1602,
        subtitle: 'No',
      },
    ],
  },
  // HC Medical History - Bipolar Disorder
  {
    id: 17,
    title: 'Bipolar Disorder',
    field: 'bipolarDisorder',
    darkColor: '#8870E6',
    lightColor: '#F0ECFF',
    content: [
      {
        subId: 1701,
        subtitle: 'Yes',
      },
      {
        subId: 1702,
        subtitle: 'No',
      },
    ],
  },
  // HC Medical History - Brain Aneurysm
  {
    id: 18,
    title: 'Brain Aneurysm',
    field: 'brainAneurysm',
    darkColor: '#44B277',
    lightColor: '#E1F7EC',
    content: [
      {
        subId: 1801,
        subtitle: 'Yes',
      },
      {
        subId: 1802,
        subtitle: 'No',
      },
    ],
  },
  // HC Medical History - Cancer
  {
    id: 19,
    title: 'Cancer',
    field: 'cancer',
    darkColor: '#FB6C66',
    lightColor: '#FFEEE4',
    content: [
      {
        subId: 1901,
        subtitle: 'Yes',
      },
      {
        subId: 1902,
        subtitle: 'No',
      },
    ],
  },
  // HC Medical History - Depression
  {
    id: 20,
    title: 'Depression',
    field: 'depression',
    darkColor: '#8870E6',
    lightColor: '#F0ECFF',
    content: [
      {
        subId: 2001,
        subtitle: 'Yes',
      },
      {
        subId: 2002,
        subtitle: 'No',
      },
    ],
  },
  // HC Medical History - Diabetes
  {
    id: 21,
    title: 'Diabetes',
    field: 'diabetes',
    darkColor: '#44B277',
    lightColor: '#E1F7EC',
    content: [
      {
        subId: 2101,
        subtitle: 'Yes',
      },
      {
        subId: 2102,
        subtitle: 'No',
      },
    ],
  },
  // HC Medical History - Epilepsy
  {
    id: 22,
    title: 'Epilepsy',
    field: 'epilepsy',
    darkColor: '#FB6C66',
    lightColor: '#FFEEE4',
    content: [
      {
        subId: 2201,
        subtitle: 'Yes',
      },
      {
        subId: 2202,
        subtitle: 'No',
      },
    ],
  },
  // HC Medical History - Muscle Disease
  {
    id: 23,
    title: 'Muscle Disease',
    field: 'muscleDisease',
    darkColor: '#8870E6',
    lightColor: '#F0ECFF',
    content: [
      {
        subId: 2301,
        subtitle: 'Yes',
      },
      {
        subId: 2302,
        subtitle: 'No',
      },
    ],
  },
  // HC Medical History - Schizophrenia
  {
    id: 24,
    title: 'Schizophrenia',
    field: 'schizophrenia',
    darkColor: '#44B277',
    lightColor: '#E1F7EC',
    content: [
      {
        subId: 2401,
        subtitle: 'Yes',
      },
      {
        subId: 2402,
        subtitle: 'No',
      },
    ],
  },
  // HC Medical History - Respiratory disease
  {
    id: 25,
    title: 'Respiratory disease (e.g., COPD, asthma, emphysema)',
    field: 'respiratoryDisease',
    darkColor: '#FB6C66',
    lightColor: '#FFEEE4',
    content: [
      {
        subId: 2501,
        subtitle: 'Yes',
      },
      {
        subId: 2502,
        subtitle: 'No',
      },
    ],
  },
  {
    id: 99,
    title:
      'Are you a caregiver or family member of a patient with ALS?',
    field: 'isCaregiverOfALS',
    darkColor: '#8870E6',
    lightColor: '#F0ECFF',
    content: [
      {
        subId: 9901,
        subtitle: 'Yes',
      },
      {
        subId: 9902,
        subtitle: 'No',
      },
    ],
  }
];
